import React from "react";
import { ContentSection, GridRow, GridColumn, WarningMessage } from "sprint-common-web";

import { LanguagesDataProvider } from "../../../../../../../common/data/lookup-data-providers/LanguagesDataProvider";
import {
    ensureVideoFileRecordDetails,
    FileRecordDetails
} from "../../../../../../common/file-record-details/FileRecordDetails";
import {
    VideoFileRecordSoundtrackLanguagesView,
    VideoFileRecordSubtitlesLanguagesView
} from "../../../../../../common/file-record-details/languages/VideoFileRecordLanguagesSection";

interface VideoFileRecordLanguagesSectionProps {
    height: number;
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const VideoFileRecordLanguagesSection = ({
    height,
    fileRecordDetails,
    isFileRecordDetailsLoading
}: VideoFileRecordLanguagesSectionProps): JSX.Element => {
    ensureVideoFileRecordDetails(fileRecordDetails);

    let multipleSoundtracksWarning = null;

    if (fileRecordDetails.soundtracks && fileRecordDetails.soundtracks.length > 1) {
        multipleSoundtracksWarning = (
            <WarningMessage
                message={`More than one soundtrack was detected. ${fileRecordDetails.soundtracks[0].name} will be used.`}
                styles={{ root: { marginBottom: 20 } }}
            />
        );
    }

    return (
        <LanguagesDataProvider>
            <GridRow>
                <GridColumn sm={6}>
                    <ContentSection
                        header="File record soundtrack"
                        isLoading={isFileRecordDetailsLoading}
                        testId="languages-content-section"
                        childrenWrapperStyle={{ maxHeight: height }}
                    >
                        {multipleSoundtracksWarning}
                        <VideoFileRecordSoundtrackLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
                    </ContentSection>
                </GridColumn>
                <GridColumn sm={6}>
                    <ContentSection
                        header="File record subtitle"
                        isLoading={isFileRecordDetailsLoading}
                        testId="subtitle-content-section"
                    >
                        <VideoFileRecordSubtitlesLanguagesView fileRecordDetails={fileRecordDetails} height={height} />
                    </ContentSection>
                </GridColumn>
            </GridRow>
        </LanguagesDataProvider>
    );
};
